<template>
  <div v-if="links.length > 0" class="mb-2">
    <nav class="sm:hidden" aria-label="Back">
      <RouterLink
        :to="links[links.length - 1].path"
        class="flex items-center text-sm font-medium text-neutral-500 hover:text-neutral-700">
        <i
          class="fa-sharp fa-regular fa-fw fa-chevron-left -ml-1 mr-1 shrink-0 text-neutral-400"
          aria-hidden="true"></i>
        Back
      </RouterLink>
    </nav>
    <nav class="hidden sm:flex" aria-label="Breadcrumb">
      <ol role="list" class="flex items-center space-x-2">
        <NtBreadcrumbItem
          v-for="(link, i) in links"
          :key="link.id"
          :path="link.path"
          :label="link.name"
          :divider="i > 0" />
      </ol>
    </nav>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useSystemStore } from '@/stores/system'
import NtBreadcrumbItem from './NtBreadcrumbItem.vue'

export default {
  computed: {
    ...mapState(useSystemStore, ['routes']),
    links() {
      let links = []
      if (!this.routes) {
        return links
      }

      let route = this.routes.find((r) => r.id === this.$route.meta.parent_id)
      while (route) {
        if (route.show_tabs) {
          route = this.routes.find((r) => r.id === route.parent_id)
          continue
        }

        let parentRoute = this.routes.find((r) => r.id === route.parent_id && r.show_tabs)
        const name = `page${route.id}`
        links.unshift({
          id: route.id,
          path: this.$router.resolve({ name }).fullPath,
          name: parentRoute ? `${parentRoute.name} / ${route.name}` : route.name
        })
        route = this.routes.find((r) => r.id === route.parent_id)
      }
      return links
    }
  },
  components: { NtBreadcrumbItem }
}
</script>
